// One page size for every server-paginated list (DESIGN-CONCEPT §9.1: "Page size
// fixed at 20 (one constant in src/constants/), navigated by the shared Pager").
// Consumers: Encounters (Accounting still carries its legacy 50 — migrate it to
// this constant when that screen is next touched).
export const PAGE_SIZE = 20;
